import config from '../config/index';

console.log('conffffff',config.EnvName)

var network = {};

if(config.EnvName == 'production'){
    network = {
    //            Live
  
    ETH: {
      
    //   //              ETH
  
      currencySymbol: "ETH",
      COIN_NAME: "ETH",
      tokenSymbol: "WETH",
      TradeContract: "0x1494E0359De493f785a595b7201A3f89D3Ec2C44".toLowerCase(),
      RPC_URL: "https://ethereum-rpc.publicnode.com",
      networkVersion: "1",
      chainId: "0x1",
      CHAIN_ID: 1,
      ChainId: 1,
      name: "ETH",
      EvmName: "ETH",
      label: "ETH",
      value: "ETH",
      chainCurrency: {
        name: "Ethereum",
        symbol: "ETH",
        decimals: 18,
      },
      BlockChain: "Ethereum",
      chainName: "Ethereum",
      blockexplorerUrl: "https://etherscan.io",
      key: "ETH", //      key of this object
      // 0xaa36a7
    //   img: require("../../assests/img/eth2.png"),
    },
  
    BSC: {
      ////////////////////////////binance/////////////////////////////
  
      currencySymbol: "BNB",
      COIN_NAME: "BNB",
      tokenSymbol: "WBNB",
      TradeContract: "0x267fd4bd9b65bd6a6def56ee89bfbb33538c62dc".toLowerCase(),
      RPC_URL: "https://bsc-dataseed.binance.org",
      networkVersion: "56",
      chainId: "0x38",
      CHAIN_ID: 56,
      ChainId: 56,
      name: "Binance",
      EvmName: "BSC",
      label: "BNB",
      value: "Binance",
      chainCurrency: {
        name: "BNB",
        symbol: "BNB",
        decimals: 18,
      },
      BlockChain: "Binance",
      chainName: "BSC",
      blockexplorerUrl: "https://bscscan.com",
      key: "BSC",
    //   img: require("../../assests/img/bnb2.png"),
    },

    //            Live
    
  }
}
else{
  network = {
    //            Local
    
      ETH: {
        //              Sepolia
    
        currencySymbol: "ETH",
        COIN_NAME: "ETH",
        TradeContract: "0x22b5cddA93CCdaCFae30931F00DEc3e454347633".toLowerCase(),
        RPC_URL: "https://ethereum-sepolia.blockpi.network/v1/rpc/public",
        networkVersion: "11155111",
        chainId: "0xaa36a7",
        CHAIN_ID: 11155111,
        ChainId: 11155111,
        name: "Sepolia",
        EvmName: "Sepolia_TESTNET",
        label: "Sepolia",
        value: "Sepolia",
        chainCurrency: {
          name: "Sepolia",
          symbol: "Sepolia",
          decimals: 18,
        },
        BlockChain: "Sepolia Testnet",
        chainName: "Sepolia test network",
        blockexplorerUrl: "https://testnet.bscscan.com",
        key: "ETH", //      key of this object
        // 0xaa36a7
        // img: require("../../assests/img/eth2.png"),
      },
    
      BSC: {
        ////////////////////////////binance/////////////////////////////
    
        currencySymbol: "BNB",
        COIN_NAME: "BNB",
        TradeContract: "0x11F572cB68B739e57C48F40ea7403cae9883EFcb".toLowerCase(),
        RPC_URL: "https://bsc-testnet-rpc.publicnode.com",
        networkVersion: "97",
        chainId: "0x97",
        CHAIN_ID: 97,
        ChainId: 97,
        name: "Binance",
        EvmName: "BSC_TESTNET",
        label: "BNB",
        value: "Binance",
        chainCurrency: {
          name: "BNB",
          symbol: "BNB",
          decimals: 18,
        },
        BlockChain: "Binance Testnet",
        chainName: "BSC-Testnet",
        blockexplorerUrl: "https://testnet.bscscan.com",
        key: "BSC",
        // img: require("../../assests/img/bnb2.png"),
      },
    
    
      //            Local
      }
}


export default network;